import * as React from 'react';
import ReactDOM from 'react-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import { element, number, func } from 'prop-types';
import { Flex, Box } from 'grid-styled';

class ChartHScroll extends React.Component {
  componentDidMount() {
    this.props.setTooltipXOffset(this.props.width - this.body.getClientWidth());
  }

  componentWillReceiveProps(nextProps) {
    const { selectedId } = this.props;
    if (nextProps.selectedId !== selectedId) {
      const firstBar = ReactDOM.findDOMNode(this).getElementsByClassName(
        `bar-${nextProps.selectedId}`,
      )[0];
      if (firstBar) {
        this.body.scrollLeft(firstBar.dataset.x - 20);
      }
    }
  }

  render() {
    const { width, height, leftAxisElem, children, setScrollX } = this.props;

    return (
      <Flex style={{ width, height }}>
        <Box ref={el => (this.leftBox = el)}>{leftAxisElem}</Box>
        <Scrollbars
          ref={el => (this.body = el)}
          style={{ flex: '1 1 auto' }}
          onWheel={e =>
            this.body.scrollLeft(this.body.getScrollLeft() + e.deltaY)
          }
          onScrollStop={() => setScrollX(this.body.getScrollLeft())}
        >
          {children}
        </Scrollbars>
      </Flex>
    );
  }
}

ChartHScroll.propTypes = {
  width: number.isRequired,
  height: number.isRequired,
  leftAxisElem: element.isRequired,
  setScrollX: func.isRequired,
  setTooltipXOffset: func.isRequired,
  children: element.isRequired,
};

export default ChartHScroll;



// WEBPACK FOOTER //
// ./src/components/ChartHScroll.jsx